import React, { Component } from 'react'
import '../styles/Blacklist.css'

class Number extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <tr>
                <td>
                    {this.props.number.number}
                </td>
                <td>
                    {this.props.number.lastcall}
                </td>
            </tr>
        )
    }
}

class NumbersContainer extends Component {
    render() {
        return (
            <table>
                <tbody>
                    <tr><th>numéro</th><th>appel précedent</th></tr>
                    {this.props.numbers.map((number, id) =>
                        <Number key={id} number={number}/>
                    )}
                </tbody>
            </table>
        )
    }
}

export default NumbersContainer